import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import RoofersHero from '../components/RoofersLanding/RoofersHero'
import SocialProof from '../components/RoofersLanding/SocialProof'
import CampaignStrategy from '../components/RoofersLanding/CampaignStrategy'
import WhyOLM from '../components/RoofersLanding/WhyOLM'
import HowItWorks from '../components/RoofersLanding/HowItWorks'
import FAQ from '../components/RoofersLanding/FAQ'
import BookingSection from '../components/RoofersLanding/BookingSection'
import Footer from '../components/Footer'

export default function Roofers({ data }) {
    return (
        <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
            <Header meta={data?.yoast_head} />
            <RoofersHero />
            <SocialProof />
            <CampaignStrategy />
            <WhyOLM />
            <HowItWorks />
            <FAQ />
            <BookingSection />
            <Footer />

            <style
                dangerouslySetInnerHTML={{
                    __html: `
                @media (max-width: 640px) {
                    .roofers-form-grid {
                        grid-template-columns: 1fr !important;
                        padding: 20px !important;
                        gap: 16px !important;
                    }
                    .roofers-form-footer {
                        justify-content: center !important;
                        text-align: center;
                    }
                    .roofers-form-footer button {
                        width: 100%;
                    }
                }
            `,
                }}
            />
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    let data = {}

    try {
        const page = await GeneralAPI.getPageBySlug('/roofers')
        data = page ? page[0] || {} : {}
    } catch (e) {
        console.error(e)
    }

    try {
        const { banners } = await GeneralAPI.getACFBanners()
        data.banners = banners
    } catch (e) {
        console.error(e)
    }

    return {
        props: {
            data,
            phoneNumber: '978-893-5890',
        },
        revalidate: 10,
    }
}
